/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';
import { InputText } from "primereact/inputtext";
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Checkbox } from "primereact/checkbox";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import MarkupViewer from '../../MarkupViewer';
import FileUploader from '../../FileUploader'
import MarkupChanger from '../../MarkupChanger';
import FormBuilder from '../../FormBuilder';
import LayoutChanger from '../../LayoutChanger';

import { setLPDetails } from '../../../slices/createLPSlice';



import './netLineTemplate.css';
import { LandingPageServe } from '../../../services/api/LandingPageServ';


const NetLinePOC = () => {
  // let i = 0;
  const toast = useRef(null);
  const lpDetails = useSelector((state) => state.createLp.data);
  const isEditable = useSelector((state) => state.auth.isEditable);
  const isLogged = useSelector((state) => state.auth.isLogged);
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(isEditable);
  const [currentEditSection, setCurrentEditSection] = useState('');
  const [viewUploader, setViewUploader] = useState(false);
  const [viewEditor, setViewEditor] = useState(false);
  const [viewFormBuilder, setViewFormBuilder] = useState(false);
  const [viewLayoutChanger, setViewLayoutChanger] = useState(false)
  const [layout, setLayout] = useState(lpDetails.lplayout);
  const [templateNo , setTemplateNo] = useState(lpDetails.templateNo);
  const [content, setContent] = useState(null)
  const [markup, setMarkup] = useState('')
  const [emailLayout, setemailLayout] = useState(lpDetails.emaillayout);
  // const [isWebinar, setisWebinar] = useState(false);

  const getFormErrorMessage = (name) => {
    return errors[name] ? <small className="p-error"  style={{ display : "flex" , marginBottom : "20px" , marginLeft :'25px'  }}>{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
  };




  const {
    formState: { errors },
    handleSubmit,
    control,
    reset
  } = useForm();

  const {
    fields: itemFields,
    append: appendItem,
    remove: removeItem
  } = useFieldArray({
    control,
    name: "Items"
  })



  useEffect(() => {
   
    if (isLogged) {
      setEditMode(isEditable)
    } else {
      setEditMode(false)
    }

    if (lpDetails._id) {
      setLayout(lpDetails.lplayout);
      document.title =lpDetails['lplayout']['title']['text'];
    }
    if (lpDetails.fields.length > 0) {
      reset()
      for (const f of lpDetails.fields) {
        appendItem(f)
      }
    }
  }, [lpDetails])



  const dispatchLayout = (obj) => {
    setTemplateNo(localStorage.getItem('template_index'));
    dispatch(setLPDetails({ lplayout: { ...layout, ...obj } }))
    console.log(lpDetails);
  }

   const dispatchEmailLayout=(obj) => {
      let footerObj = {}
      if(obj['headerLogo']){
        footerObj = {footerLogo:{ url: obj.headerLogo.url}}
        setLPDetails({emaillayout: {...emailLayout , ...footerObj}})
      } 
      dispatch(setLPDetails( { emaillayout: { ...emailLayout, ...obj , ...templateNo }}))
    }

  const dispatchFields = (data) => {
    dispatch(setLPDetails({ fields: [...itemFields, ...[data]] }))
  }

  const onFormSubmit = async (data) => {
    try {
      delete data['Items']
      if (!isEditable) {
        await LandingPageServe.saveform({ lpId: lpDetails._id, lead: data });
      }
      reset()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
      window.open(lpDetails.assetLink,"_self")
    } catch (error) {
      console.log(error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message });

    }
  };

  const handleClick = (type) => {
    setCurrentEditSection(type)
    if (type === 'HEADER_LOGO' || type === 'HERO_IMAGE' || type === 'FOOTER_LOGO') {
      setViewUploader(true)
    }
    if (type === 'TITLE') {
      setContent(layout.title)
      setViewLayoutChanger(true)
    }
    if (type === 'FORM_TITLE') {
      setContent(layout.formTitle)
      setViewLayoutChanger(true)
    }

    if (type === 'HERO_CONTENT') {
      setMarkup(layout.heroContent)
      setViewEditor(true)
    }
    if (type === 'ACTION_BTN') {
      setContent(layout?.actionButton)
      setViewLayoutChanger(true)
    }
    if (type === 'FOOTER_CONTENT') {
      setMarkup(layout.footerContent);
      setViewEditor(true)
    }
  };

  const handleAdd = () => {
    setViewFormBuilder(true)
  };

  const handleRemove = (i) => {
    removeItem(i)
  };

  const handleCloseEditor = (data , isWebinar , duration , webinarTitle) => {
    console.log(isWebinar , duration);
    let obj = {}
    if (currentEditSection === 'HERO_CONTENT') {
      obj = { 
        heroContent: data ,
        isWebinar : isWebinar || false,
        duration : duration || null,
        webinarTitle :webinarTitle || null,
       
      }
      // setisWebinar(isWebinar);
    }
    if (currentEditSection === 'FOOTER_CONTENT') {
      obj = { footerContent: data }
    }

    
   

    setViewEditor(false)
    dispatchLayout(obj);
    // dispatchEmailLayout(obj);
  }

  const handleCloseUploader = (data,width,height) => {
    // console.log(width,height);
    if (data) {
      
      let obj = {}
      if (currentEditSection === 'HEADER_LOGO') {
        obj = { headerLogo: { url: data.Location , 
                              width : width ||  '420px', 
                              height : height || null} 
              }
      }
      if (currentEditSection === 'HERO_IMAGE') {
        obj = { heroImage: { url: data.Location , 
                            width : width || '360px' , 
                            height : height || null} 
              }
      }
      if (currentEditSection === 'FOOTER_LOGO') {
        obj = { footerLogo:{ url: data.Location , 
                              width : width || null , 
                              height :height || null} 
              }
      }
      dispatchLayout(obj);
      // dispatchEmailLayout(obj);
    }
    setViewUploader(false)
  }

  const handleCloseBuilder = (data) => {
    setViewFormBuilder(false);
    if (data && Object.keys(data).length > 0) {
      appendItem(data);
      dispatchFields(data)
    }
  }


  const handleCloseLayoutChanger = (data) => {
    // console.log(data);
    let obj = {}
    if (data) {
      if (currentEditSection === 'TITLE') {
        obj = {
          title: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            subtitle : data.subtitle,
            type : data.type || null
          }
        }
      }
      if (currentEditSection === 'ACTION_BTN') {
        obj = {
          actionButton: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      if (currentEditSection === 'FORM_TITLE') {
        obj = {
          formTitle: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      dispatchLayout(obj);
      // dispatchEmailLayout(obj);

    }
    setViewLayoutChanger(false)
  }


  const getAddRemove = (i) => {
    return (
      <>
        <FaCircleMinus onClick={(() => handleRemove(i))} className='mt-3' style={{ color: "red" }} />
        {(itemFields.length - 1) === i && <FaCirclePlus onClick={(() => handleAdd())} className='mt-3 ml-2' style={{ color: "green" }} />}

      </>
    )
  }

  const getField = (item, i) => {
    return (
      <>
        {
          item.type === 'text' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '20px' , marginLeft : '30px'  }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (

                  <>
                     <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label> 
                    <span className='w-336'>
                      <InputText id={field.name} placeholder={item.label}  value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                     {/* <label htmlFor={field.name}>{item.label}*</label> */}
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div >{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>

        }
        {
  item.type === 'email' &&
  <span className="field">
    <div
      className="flex justify-content-center"
      style={{ height: "45px", marginTop: "5px" }}
    >
      <Controller
        name={item.name}
        control={control}
        rules={{
          required: item.message,
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }}
        render={({ field, fieldState }) => (
          <>
            <span className="w-336-bc">
              <InputText
                id={field.name}
                value={field.value}
                type="email"
                className={classNames({ 'p-invalid': fieldState.error })}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </span>
          </>
        )}
      />
      <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
        {editMode && <div>{getAddRemove(i)}</div>}
      </div>
    </div>

    <span>{getFormErrorMessage(item.name)}</span>
  </span>
}

        {
          item.type === 'select' &&
          <span className='field'>
            <div className="flex justify-content-center" key={item.id} style={{padding: '0px 0px 0px 10px', marginLeft: '20px'}}> 
              <Controller
                style={{ width: "277px", }}
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                      <Dropdown
                        id={field.name}
                        value={field.value}
                        optionLabel="label"
                        placeholder={item.label}
                        options={item.options}
                        focusInputRef={field.ref}
                        onChange={(e) => field.onChange(e.value)}
                        className={classNames({ 'p-invalid': fieldState.error })}
                      />
                  </>

                )}
              />

              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
        {
          item.type === 'number' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '20px'  }} >
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name}  className={classNames({ 'p-error': errors.value })}></label>
                    <span className='w-336'>
                      <InputText keyfilter="int" id={field.name} value={field.value}  className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                      {/* <label htmlFor={field.name}>{item.label}*</label> */}
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
        {
          item.type === 'check' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ width: "100%" , height: "auto" , marginTop : '20px' ,padding: '0px 25px 30px 25px' }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.checked })}></label>
                    <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                  </>
                )}
              />
              <label htmlFor="ingredient1" className="ml-2 opt-in"><MarkupViewer htmlString={item.label}></MarkupViewer></label>
              <div className={`${itemFields.length - 1 === i  && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div className='check'>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
      </>

    )
  }






  return (
    <>
      <Toast ref={toast}></Toast>
      <div style={{ marginTop: "5px" }}>
        <div
          className={`row center-align ${editMode ? "u-hover--sparkle" : ""}`}
          onClick={editMode ? (() => handleClick('HEADER_LOGO')) : undefined}
        >
          <img
            className={`${editMode ? "u-hover--sparkle" : ""} header-logo`}
            style={{width : layout?.headerLogo?.width || '26%' , height : layout?.headerLogo?.height || 'auto'}}
            src={layout?.headerLogo?.url} 
            alt="Header logo"
          ></img>
        </div>

        <div className={`${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('TITLE')) : undefined} >
          {
             layout?.title?.type !== null && <p className='poc-type'>{layout?.title?.type }</p>
          }
         
          <div className="row center-align">
            <h2 className="title" style={{ color: layout?.title?.textColor || 'black' , paddingBottom : (layout?.title?.subtitle && layout?.title?.subtitle !== '') ? '0px' : '40px' }}>{layout.title?.text}</h2>
          </div>
          { (layout?.title?.subtitle && (layout?.title?.subtitle !== '' || layout?.title?.subtitle !== null)) &&
              <div className="row center-align">
              <p className="sub-title" style={{ color: layout?.title?.textColor || 'black' }}>{layout?.title?.subtitle}</p>
              </div>
          }
        
        </div>

        <div className="grid " style={{ marginTop: "30px" }}>
          <div className={`md:col-offset-0 md:col-6 col-12 text-center`}>
            <div className={`${editMode ? "u-hover--sparkle" : ""} position-asset-img`} onClick={editMode ? (() => handleClick('HERO_IMAGE')) : undefined}>
              <img
                className={`${editMode ? "u-hover--sparkle" : ""} asset_img`}
                style={{width : layout?.heroImage?.width || '80%' , height : layout?.heroImage?.height || 'auto'}}
                src={layout?.heroImage?.url}
                alt="Header logo"
              />
            </div>
          </div>
          <div className={`md:col-offset-0 md:col-6 col-12 text-center`}>
            <div className="des-form">
              <div style={{ color: layout?.formTitle?.textColor , backgroundColor: layout?.formTitle?.backgroundColor , padding : '0'  , margin :'0'}}>
              <h4 
                className={`${editMode ? "u-hover--sparkle" : ""}`}
                onClick={editMode ? () => handleClick("FORM_TITLE") : undefined}
                style={{
                  fontSize: "20px",
                  color: layout?.formTitle?.textColor,
                  padding : '12px'
                }}
              >
                {layout?.formTitle?.text}
              </h4>
              </div>
              <div
                className={`set-padding ${editMode ? "u-hover--sparkle" : ""}` }  onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}
              >
               <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
              </div>
              <form onSubmit={handleSubmit(onFormSubmit)}>
                {itemFields &&
                  itemFields.map((item, index) => (
                    <div key={item.id}> {getField(item, index)}</div>
                  ))}
                <div
                  className={`flex justify-content-center ${
                    editMode ? "u-hover--sparkle" : ""
                  }`}
                  onClick={
                    editMode ? () => handleClick("ACTION_BTN") : undefined
                  }
                >
                  <Button
                    label={layout?.actionButton?.text}
                    style={{
                      marginBottom :'30px',
                      backgroundColor:
                        layout?.actionButton?.backgroundColor || "#087d95",
                      color: layout?.actionButton?.textColor || "white",
                    }}
                    type="submit"
                    outlined
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {viewUploader && (
        <FileUploader
          open={viewUploader}
          handleCloseUploader={handleCloseUploader}
        ></FileUploader>
      )}
      {viewEditor && (
        <MarkupChanger
          open={viewEditor}
          text={markup}
          handleCloseEditor={handleCloseEditor}
        ></MarkupChanger>
      )}
      {viewFormBuilder && (
        <FormBuilder
          open={viewFormBuilder}
          data={markup}
          handleCloseBuilder={handleCloseBuilder}
        ></FormBuilder>
      )}
      {viewLayoutChanger && (
        <LayoutChanger
          open={viewLayoutChanger}
          data={content}
          handleCloseLayoutChanger={handleCloseLayoutChanger}
        ></LayoutChanger>
      )}
    </>
  );
}

export default NetLinePOC